import {fillInputsByName} from "../../helpers/forms";
import {getSingleInputElementByNameV3} from "../../helpers/forms/formInputsHelpers";

function initOrderDebugEntry() {
    return {
        test: () => {
            const url = window.location.href;
            return url.match(/(\/admin\/order$)|(\/v2\/tickets)|(\/v2\/admin\/orders\/[^\\]+\/transactions\/create)|(\/v2\/admin\/tickets)|(\/purchasing$)|(\/v2\/admin\/purchasing)|(\/purchasing\/s\/.*$)|(\/purchasing-legacy$)/);
        },
        entry: 'Fill Customer Fields',
        action: () => {
            fillInputsByName(document, {
                first_name: `TEST FIRST`,
                last_name: `TEST LAST`,
                phone: '1231231231',
                email: 'example@example.com',
                address1: 'EXAMPLE ADDRESS',
                address2: 'EXAMPLE ADDRESS',
                city: 'EXAMPLE CITY',
                zip: '12345',
                state: 'Alabama',

                // CC info
                cc_number: '4007000000027',
                cc_month: '12',
                cc_year: '2030',
                cc_cvv: '123',
            })

            // Trigger change event
            const nameElement = getSingleInputElementByNameV3(document.body, 'first_name');
            nameElement.dispatchEvent(new InputEvent('change'));
        }
    }
}

export {initOrderDebugEntry}

